import {
  USER_STATUS_CODE_ACTIVE,
  USER_STATUS_CODE_BLOCKED,
  USER_STATUS_CODE_IMPORTED,
  USER_STATUS_CODE_INVITED,
  USER_STATUS_CODE_NOT_CONFIRMED,
} from '../../../constants/user'
import { USER_PROFILE_ACTION, USER_PROFILE_ACTION_PERMISSION } from '../../User'

import SendInviteIcon from '../../../icons/add-to-contacts.svg'
import ArchiveIcon from '../../../icons/archive.svg'
import BlockIcon from '../../../icons/block-user.svg'
import DeleteIcon from '../../../icons/delete.svg'
import DownloadIcon from '../../../icons/export.svg'
import RestoreIcon from '../../../icons/restore.svg'
import UnblockIcon from '../../../icons/unblock-user.svg'

export const USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION = {
  ...USER_PROFILE_ACTION,
  download: 'download',
}

export const USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION_PERMISSION = {
  ...USER_PROFILE_ACTION_PERMISSION,
  [USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.download]: 'can_view_files',
}

export const USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION_ICON = {
  [USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.archive]: ArchiveIcon,
  [USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.block]: BlockIcon,
  [USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.delete]: DeleteIcon,
  [USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.download]: DownloadIcon,
  [USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.restore]: RestoreIcon,
  [USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.sendInvite]: SendInviteIcon,
  [USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.unblock]: UnblockIcon,
}

export const USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION_TOOLTIP_KEY = {
  [USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.addNew]:
    'UserProfile.ActionsWidgetAddNewTooltipKey',
  [USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.archive]:
    'UserProfile.ActionsWidgetArchiveTooltipKey',
  [USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.block]:
    'UserProfile.ActionsWidgetBlockTooltipKey',
  [USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.delete]: 'Modal.DeleteBtnKey',
  [USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.download]:
    'UserProfile.ActionsWidgetDownloadAllTooltipKey',
  [USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.restore]:
    'UserProfile.ActionsWidgetRestoreTooltipKey',
  [USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.sendInvite]:
    'UserProfile.ActionsWidgetSendInviteTooltipKey',
  [USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.unblock]:
    'UserProfile.ActionsWidgetUnblockTooltipKey',
}

export const USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTIONS_BY_STATUS = {
  [USER_STATUS_CODE_ACTIVE]: [
    USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.addNew,
    USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.download,
    USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.block,
    USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.archive,
  ],
  [USER_STATUS_CODE_BLOCKED]: [
    USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.addNew,
    USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.sendInvite,
    USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.download,
    USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.unblock,
    USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.archive,
  ],
  [USER_STATUS_CODE_IMPORTED]: [
    USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.addNew,
    USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.sendInvite,
    USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.download,
    USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.block,
    USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.archive,
  ],
  [USER_STATUS_CODE_INVITED]: [
    USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.addNew,
    USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.sendInvite,
    USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.download,
    USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.block,
    USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.archive,
  ],
  [USER_STATUS_CODE_NOT_CONFIRMED]: [
    USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.addNew,
    USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.download,
    USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.block,
    USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.archive,
  ],
}

export const USER_PROFILE_PAGE_ACTIONS_WIDGET_ARCHIVED_ACTIONS = [
  USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.sendInvite,
  USER_PROFILE_PAGE_ACTIONS_WIDGET_ACTION.restore,
]
